import React from 'react';
import PropTypes from 'prop-types';

const renderThisCell = (filter, highlight, value, height) => {
  const computedValue = value.replace(',', '').replace('**', '').replace('*', '').replace('%', '');
  const highlightAndFilterStyles = {};
  highlightAndFilterStyles.height = height;
  highlightAndFilterStyles.display = 'flex';
  highlightAndFilterStyles.alignItems = 'center';
  for (const x of filter) {
    if (
      x.operator === 'Greater Than' && computedValue > Number(x.value)
    ) {
      highlightAndFilterStyles.color = 'transparent !important';
      highlightAndFilterStyles.opacity = 0;
    } else if (
      x.operator === 'Less Than' && computedValue < Number(x.value)
    ) {
      highlightAndFilterStyles.color = 'transparent !important';
      highlightAndFilterStyles.opacity = 0;
    } else if (
      x.operator === 'Equals' && computedValue === Number(x.value)
    ) {
      highlightAndFilterStyles.color = 'transparent !important';
      highlightAndFilterStyles.opacity = 0;
    } else if (
      x.operator === 'Range' &&
      Number(x.value.split(' to ')[0]) <= computedValue &&
      computedValue <= Number(x.value.split(' to ')[1])
    ) {
      highlightAndFilterStyles.color = 'transparent !important';
      highlightAndFilterStyles.opacity = 0;
    }
  }
  for (const i of highlight) {
    if (
      i.operator === 'Greater Than' &&
      computedValue > Number(i.value)
    ) {
      if (i.textColor) {
        highlightAndFilterStyles.color = i.textColor;
      }
      if (i.cellColor) {
        highlightAndFilterStyles.backgroundColor = i.cellColor;
      }
    } else if (
      i.operator === 'Less Than' &&
      computedValue < Number(i.value)
    ) {
      if (i.textColor) {
        highlightAndFilterStyles.color = i.textColor;
      }
      if (i.cellColor) {
        highlightAndFilterStyles.backgroundColor = i.cellColor;
      }
    } else if (
      i.operator === 'Equals' &&
      computedValue === Number(i.value)
    ) {
      if (i.textColor) {
        highlightAndFilterStyles.color = i.textColor;
      }
      if (i.cellColor) {
        highlightAndFilterStyles.backgroundColor = i.cellColor;
      }
    } else if (
      i.operator === 'Range' &&
      Number(i.value.split(' to ')[0]) <= computedValue &&
      computedValue <= Number(i.value.split(' to ')[1])
    ) {
      if (i.textColor) {
        highlightAndFilterStyles.color = i.textColor;
      }
      if (i.cellColor) {
        highlightAndFilterStyles.backgroundColor = i.cellColor;
      }
    }
  }
  return (<div title={value} style={highlightAndFilterStyles}>{value}</div>);
};

const StyledCell = ({ filter, highlight, value, height }) => {
  return (renderThisCell(filter, highlight, value, height));
};

StyledCell.propTypes = {
  filter: PropTypes.arrayOf(PropTypes.shape({})),
  highlight: PropTypes.arrayOf(PropTypes.shape({})),
  value: PropTypes.string,
};

export default StyledCell;
